import { render, staticRenderFns } from "./Flag.vue?vue&type=template&id=e17e15a2&"
import script from "./Flag.vue?vue&type=script&lang=js&"
export * from "./Flag.vue?vue&type=script&lang=js&"
import style0 from "./Flag.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports